module.exports = __webpack_public_path__ + "img/integratedImg.590b25db.png";